import { create } from 'zustand';
import { ApiUtils, CardApi, type CardEntity, type StoreBaseReturn } from '@shared/api';

interface UseUnblockCardStore {
  loading: boolean;
  data: CardEntity[];
  error: string | null;
  unblockCard: (accountId: string, signal?: AbortSignal) => Promise<StoreBaseReturn<CardEntity[]>>;
  clear: () => void;
}

export const useUnblockCardStore = create<UseUnblockCardStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  unblockCard: async (accountId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardApi.unblockCard(accountId, signal);
      set({ loading: false, data: result || [] });
      return { loading: false, data: result || [], error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: [], error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: [], error: null }),
}));
